import React from 'react';
import Home from "./Home";
import Connect from './Connect';
import Products from "./Products";
import Features from './Features';

const Aip = () => {

    return (
        <>
            <Home />
            <Connect />
            <Products />
            <Features />

        </>
    );
};

export default Aip;